<template>
  <el-dialog title="选择运价费用" :visible.sync="dialogVisible" width="900px" @close="handleClose">
    <!-- 查询条件 -->
    <div class="search-form">
      <el-form :inline="true" :model="queryForm" size="small">
        <el-form-item label="起运港">
          <portSelect v-model="queryForm.from_port" placeTitle="港口名称或代码" :width="'180px'" clearable
            ref="fromPortSelectRef" @input="from_port_input" />
        </el-form-item>
        <el-form-item label="目的港">
          <portSelect v-model="queryForm.dest_port" placeTitle="港口名称或代码" :width="'180px'" clearable
            ref="destPortSelectRef" @input="dest_port_input" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleSearch" :loading="loading">查 询</el-button>
          <el-button @click="resetQuery">重 置</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!-- 运价列表 -->
    <div class="tableBlock">
      <el-table :data="quotationList" style="width: 100%" v-loading="loading" border fit height="450px">
        <el-table-column prop="quotation_id" width="0" v-if="false"></el-table-column>
        <el-table-column label="起运港" min-width="20%" show-overflow-tooltip>
          <template slot-scope="scope">
            <template v-if="queryInfo.spell_type === 1">
              {{ scope.row.from_port_name_en }}
            </template>
            <template v-else>
              {{ scope.row.from_port }}
            </template>
          </template>
        </el-table-column>
        <el-table-column label="中转港" min-width="20%" show-overflow-tooltip>
          <template slot-scope="scope">
            <template v-if="queryInfo.spell_type === 1">
              {{ scope.row.trans_port_name_en }}
            </template>
            <template v-else>
              {{ scope.row.trans_port }}
            </template>
          </template>
        </el-table-column>
        <el-table-column label="目的港" min-width="20%" show-overflow-tooltip>
          <template slot-scope="scope">
            <template v-if="queryInfo.spell_type === 1">
              {{ scope.row.dest_port_name_en }}
            </template>
            <template v-else>
              {{ scope.row.dest_port }}
            </template>
          </template>
        </el-table-column>
        <el-table-column label="海运费" min-width="15%" show-overflow-tooltip>
          <template slot-scope="scope">
            <template v-if="queryInfo.spell_type === 1">
              {{ scope.row.price_20gp }}
            </template>
            <template v-else>
              {{ scope.row.price_lcl_dangerous.toFixed() | textFormat }}
            </template>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="90" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="selectQuotation(scope.row)">选择</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 费用组选择弹窗 -->
    <fee-group-select
      :visible.sync="feeGroupDialogVisible"
      :quotation="selectedQuotationData"
      @confirm="handleFeeGroupConfirm"
      @cancel="feeGroupDialogVisible = false"
    />
  </el-dialog>
</template>

<script>
import portSelect from "~ymp/components/common/portSelect"
import FeeGroupSelect from "./feeGroupSelect.vue"

export default {
  name: "OrderQuotationAdd",
  components: { 
    portSelect,
    FeeGroupSelect
  },
  data() {
    return {
      dialogVisible: false,
      loading: false,
      queryForm: {
        from_port: "",
        dest_port: ""
      },
      queryInfo: {
        from_port_name: "",
        from_port_id: "",
        dest_port_name: "",
        dest_port_id: "",
        spell_type: "",
      },
      quotationList: [],
      total: 0,
      selectedQuotations: [],
      feeGroupDialogVisible: false,
      selectedQuotationData: null,
    };
  },
  methods: {
    // 起运港选择处理
    from_port_input(val, name_en) {
      if (val === '') val = null
      let num = Number(val)
      if (!isNaN(num) || val === '') {
        this.queryInfo.from_port_id = val
        this.queryInfo.from_port_name = name_en
        // 更新查询表单中的值
        this.queryForm.from_port = val
      }
    },

    // 目的港选择处理
    dest_port_input(val, name_en) {
      if (val === '') val = null
      let num = Number(val)
      if (!isNaN(num) || val === '') {
        this.queryInfo.dest_port_id = val
        this.queryInfo.dest_port_name = name_en
        // 更新查询表单中的值
        this.queryForm.dest_port = val
      }
    },

    // 打开弹窗
    open(params) {
      this.dialogVisible = true;
      this.resetQuery();

      // 如果传入了参数，设置初始查询条件
      if (params) {
        if (params.from_port_id) {
          this.queryForm.from_port = params.from_port_name;
          this.queryInfo.from_port_id = params.from_port_id;
          this.queryInfo.from_port_name = params.from_port_name;
        }
        if (params.dest_port_id) {
          this.queryForm.dest_port = params.dest_port_name;
          this.queryInfo.dest_port_id = params.dest_port_id;
          this.queryInfo.dest_port_name = params.dest_port_name;
        }
        this.queryInfo.spell_type = params.spell_type;
      }

      // 如果起运港和目的港都有值，自动查询
      if (this.queryInfo.from_port_id && this.queryInfo.dest_port_id) {
        this.fetchQuotationList();
      }
    },

    // 查询运价列表
    async fetchQuotationList() {
      if (!this.queryInfo.from_port_id || !this.queryInfo.dest_port_id) {
        this.$message.warning('请选择起运港和目的港');
        return;
      }

      this.loading = true;
      try {
        let params = {
          from_port: this.queryInfo.from_port_id,
          dest_port: this.queryInfo.dest_port_id,
          nopage: 1,
        };

        let fcl_params = {
          from_port: this.queryInfo.from_port_id,
          dest_port: this.queryInfo.dest_port_id,
          user_type: 2,
          dangerous_status: 0,
          nopage: 1,
        };

        // 根据spell_type判断调用不同的接口
        let res = null
        if (this.queryInfo.spell_type === 1) {
          res = await this.$store.dispatch("API_bookingSpace/fcl_search", fcl_params);
        } else {
          res = await this.$store.dispatch("API_bookingSpace/lcl_search", params);
        }

        if (res.success) {
          this.quotationList = res.data || [];
          this.total = res.count || 0;
        } else {
          this.$message.error(res.message || "获取运价列表失败");
          this.quotationList = [];
          this.total = 0;
        }
      } catch (error) {
        console.error("获取运价列表失败:", error);
        this.$message.error("获取运价列表失败，请稍后重试");
        this.quotationList = [];
        this.total = 0;
      } finally {
        this.loading = false;
      }
    },

    // 选择运价
    selectQuotation(row) {
      // 存储选中的运价数据，并添加spell_type
      this.selectedQuotationData = {
        ...row,
        spell_type: this.queryInfo.spell_type
      };
      // 打开费用组选择窗口
      this.feeGroupDialogVisible = true;
    },

    // 处理费用组选择确认
    handleFeeGroupConfirm(selectedFees) {
      if (!selectedFees || selectedFees.length === 0) {
        this.$message.warning('未收到费用数据');
        return;
      }
      
      // 使用 selected 事件将数据传递给父组件 customerBooking.vue
      this.$emit('selected', selectedFees);
      
      // 关闭对话框
      this.feeGroupDialogVisible = false;
      this.dialogVisible = false;
      
      this.$message.success(`已选择 ${selectedFees.length} 项费用`);
    },

    // 重置查询条件
    resetQuery() {
      // 重置查询表单
      this.queryForm = {
        from_port: "",
        dest_port: ""
      };

      // 重置港口信息
      this.queryInfo = {
        from_port_name: "",
        from_port_id: "",
        dest_port_name: "",
        dest_port_id: ""
      };

      // 重置其他相关状态
      this.quotationList = [];
      this.total = 0;

      // 清空港口选择器
      this.$nextTick(() => {
        if (this.$refs.fromPortSelectRef) {
          this.$refs.fromPortSelectRef.selectClear();
        }
        if (this.$refs.destPortSelectRef) {
          this.$refs.destPortSelectRef.selectClear();
        }
      });
    },

    // 查询按钮
    handleSearch() {
      this.fetchQuotationList();
    },

    // 关闭弹窗
    handleClose() {
      this.dialogVisible = false;
      this.resetQuery();
    }
  }
};
</script>

<style scoped lang="less">
.search-form {
  margin-bottom: 20px;
  padding: 0 5px;
}

.tableBlock {
  width: 100%;
  padding: 0 5px;
  margin-bottom: 15px;
  height: 450px;

  ::v-deep .el-table {
    width: 100%;
    table-layout: fixed;

    .el-table__body-wrapper {
      height: calc(450px - 32px);
      overflow-y: auto;
    }

    th.el-table__cell {
      background-color: #f5f7fa;
      color: #606266;
      font-weight: 500;
      text-align: center;
      padding: 4px 0;
      height: 32px;
      line-height: 20px;
      font-size: 12px;
    }

    td.el-table__cell {
      text-align: center;
      padding: 2px 0;
      height: 28px;
      line-height: 24px;
      font-size: 12px;
    }

    .cell {
      line-height: 1;
      padding-top: 0;
      padding-bottom: 0;
      padding-left: 5px;
      padding-right: 5px;
      white-space: nowrap;
    }

    .el-button--text {
      padding: 0;
      font-size: 12px;
    }
  }
}
</style>
